import React from 'react';

import { sanitizeFullName } from 'Shared/helpers';
import { createFormField } from 'Shared/utils/createFormField';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';

type Props = {
  value: {
    avatar;
    full_name: string;
    email: string;
  };
};

function OwnerField({ value: owner }: Props) {
  return (
    <div className="d-flex pt-1">
      <WpAvatar avatar={owner.avatar} />
      <span className="ml-2 align-self-center">{sanitizeFullName(owner.full_name) || owner.email}</span>
    </div>
  );
}

export default createFormField(OwnerField);
